const SESSION_STORAGE = {
  LOGGED: 'logged',
  STATIC_VALUE: {
    YES: 'yes',
    NO: 'no',
  },
};

export default SESSION_STORAGE;
